/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * document_storage_service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Data type for property values, determining storage and validation.
 */
export type DataType = (typeof DataType)[keyof typeof DataType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DataType = {
  BOOLEAN: 'BOOLEAN',
  DATE: 'DATE',
  DATE_RANGE: 'DATE_RANGE',
  NUMBER: 'NUMBER',
  STRING: 'STRING',
  SELECT_NUMBER: 'SELECT_NUMBER',
  SELECT_STRING: 'SELECT_STRING',
  TAG: 'TAG',
  ENTITY: 'ENTITY',
  LINK: 'LINK',
} as const;
